<template>
  <router-view />
</template>

<style lang="scss">
  // To load GNT all.css on any pages without LAZYLOAD.
  @import url($NXCACHE_URL + '/all/v1.5.2/css/all.css');
  #gnt_center { display: none; }
  .gnt-notice-tabs {
    pointer-events: none;
  }
  .gnt-notice-tab {
    pointer-events: all;
  }
</style>

<script>
export default {
  setup() {
    return {};
  },
};
</script>